import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-petrol px-4 py-20 text-center md:py-24" data-id="element-80" data-mp="3n1rz4lm72lkc">
      <Reveal className="mx-auto max-w-3xl" data-id="element-81" data-mp="3s1mrktlmbj7i">
        <h2 className="text-3xl font-bold leading-tight tracking-tight text-white md:text-[2.75rem]" data-id="element-82" data-mp="3s2pk15yl9tpj">
          Pronta a entrare in sala con la lezione già scritta?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-83" data-mp="2zejy4fvstyo4">
          Sei volumi, centoventi schede illustrate e tutti i piani di lezione, scaricabili subito per 19 €. Un
          pagamento unico, i file restano tuoi per sempre.
        </p>
        <CTAButton className="mt-9 w-full max-w-md py-5 text-base md:text-lg" data-id="element-84" data-mp="3e2eovqq8xsyk" />
        <p className="mt-4 font-note text-xs text-white/70" data-id="element-85" data-mp="3e4hlitlwmkc9">
          Download immediato in PDF · Pagamento unico di 19 € · Garanzia soddisfatti o rimborsati di 30 giorni
        </p>
      </Reveal>
    </section>;
}